// libs
import axios from 'axios';

// actions
import { throwError } from '../../actions/error/index';

// helpers
import getAuthToken from '../../formatting/getAuthToken';

// vars
import { GET_PLANT_COMMON_TYPES } from './types';

export function getPlantCommonTypes(query, override) {
    return async function (dispatch) {
        try {
            const q = query ? `?${query}` : '';
            const response = await axios.get(`/api/v1/plant-common-types${q}`, {
                headers: { authorization: getAuthToken() },
            });
            if (!override) {
                dispatch({ type: GET_PLANT_COMMON_TYPES, payload: response });
            }
            return response;
        } catch (error) {
            dispatch(
                throwError(
                    error,
                    'Something went wrong. We are working on a fix now!',
                ),
            );
        }
    };
}
